import { ModelIndexes } from "../../types/addContent";
import dayjs from "dayjs";

export const getSharePricePerformanceData = () => {
  const modelsLocalStorage = localStorage.getItem("ModelData");
  const oldModelsData = modelsLocalStorage ? JSON.parse(modelsLocalStorage) : [];

  const dataSource =
    oldModelsData.length === 0
      ? []
      : [
          {
            [oldModelsData[ModelIndexes.CONTENT_LIBRARY]?.chartType]: true,
          },
          {
            timePeriod: oldModelsData[ModelIndexes.TABLE_MODEL_INDEX]?.timePeriod ?? ["", ""],
            currency: oldModelsData[ModelIndexes.TABLE_MODEL_INDEX]?.currency ?? "USD",
            percentageChangeChart: !!oldModelsData[ModelIndexes.TABLE_MODEL_INDEX]?.percentageChart,
            actualTradedValueChart: !oldModelsData[ModelIndexes.TABLE_MODEL_INDEX]?.percentageChart,
            addCustomBuiltIndices: !!oldModelsData[ModelIndexes.TABLE_MODEL_INDEX]?.customBuildIndex,
            noCustomBuiltIndices: !oldModelsData[ModelIndexes.TABLE_MODEL_INDEX]?.customBuildIndex,
            addConstantLineSelection: !!oldModelsData[ModelIndexes.TABLE_MODEL_INDEX]?.staticLine,
            noConstantLineSelection: !oldModelsData[ModelIndexes.TABLE_MODEL_INDEX]?.staticLine,
          },
          {
            indexStartingPoint: oldModelsData[ModelIndexes.INDEXATION_MODEL_INDEX]?.indexStartingPoint,
          },
          {
            indexName: oldModelsData[ModelIndexes.CUSTOM_BUILD_INDEX]?.index?.indexName,
            constituentContributionApproach:
              oldModelsData[ModelIndexes.CUSTOM_BUILD_INDEX]?.index?.constituentContributionApproach,
            radioAddIndex: Object.keys(oldModelsData[ModelIndexes.CUSTOM_BUILD_INDEX] ?? {}).length >= 2 ? "Yes" : "No",
          },
          {
            lineName: oldModelsData[ModelIndexes.CONSTANT_LINE]?.line?.lineName,
            calculationApproach: oldModelsData[ModelIndexes.CONSTANT_LINE]?.line?.calculationApproach,
            radioAddLine: Object.keys(oldModelsData[ModelIndexes.CONSTANT_LINE] ?? {}).length >= 2 ? "Yes" : "No",
          },
          {
            addsecondaryVerticalAxisColumnChart: !!oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.tradingVolume,
            nosecondaryVerticalAxisColumnChart: !oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.tradingVolume,
            addsummaryTable: !!oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.summaryTable,
            nosummaryTable: !oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.summaryTable,
            addSmallLineChart: !!oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.smallLineChart,
            nosmallLineChart: !oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.smallLineChart,
            addCallOutBoxes: !!oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.callOutBoxes,
            noCallOutBoxes: !oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.callOutBoxes,
            addBackgroundShading: !!oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.backgroundShading,
            noBackgroundShading: !oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.backgroundShading,
            addVerticalLine: !!oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.verticalLine,
            noVerticalLine: !oldModelsData[ModelIndexes.CUSTOMIZE_OPTIONS]?.verticalLine,
          },
          {
            rowDataCategory: oldModelsData[ModelIndexes.SUMMARY_TABLE]?.rowDataCategory,
            summaryCompaniesIndices:
              oldModelsData[ModelIndexes.SUMMARY_TABLE]?.summaryCompaniesIndices?.map(({ name }: any) => name) ?? [],
            customIndicesNames: oldModelsData[ModelIndexes.SUMMARY_TABLE]?.customIndicesNames,
          },
          {
            smallLineChartTimePeriod: oldModelsData[ModelIndexes.SMALL_LINE_CHART]?.smallLineChartTimePeriod,
            checkboxCompaniesIncludedSmallLine:
              oldModelsData[ModelIndexes.SMALL_LINE_CHART]?.checkboxCompaniesIncludedSmallLine?.map(
                ({ name }: any) => name
              ) ?? [],
            customIndicesNames: oldModelsData[ModelIndexes.SMALL_LINE_CHART]?.customIndicesNames,
            constantLinesNames: oldModelsData[ModelIndexes.SMALL_LINE_CHART]?.constantLinesNames,
          },
          {
            companyName: oldModelsData[ModelIndexes.FORMAT_TEMPLATE]?.formatName?.split("-")[0],
            templateName: oldModelsData[ModelIndexes.FORMAT_TEMPLATE]?.formatName?.split("-")[1],
            formatTemplateSource: oldModelsData[ModelIndexes.FORMAT_TEMPLATE]?.source,
            formatTemplateNotes: oldModelsData[ModelIndexes.FORMAT_TEMPLATE]?.notes,
          },
        ];

  const indexationCompanyNames = {
    companyNames: oldModelsData[ModelIndexes.INDEXATION_MODEL_INDEX]?.company?.name,
  };

  const indexationValue = {
    value: oldModelsData[ModelIndexes.INDEXATION_MODEL_INDEX]?.value,
  };

  const indices = [1, 2, 3, 4].map((i) => {
    const key = `index${i}`;
    const index = oldModelsData[ModelIndexes.CUSTOM_BUILD_INDEX]?.[key] || {};
    return {
      indexName: index?.indexName,
      constituentContributionApproach: index?.constituentContributionApproach,
      radioAddIndex: Object.keys(oldModelsData[ModelIndexes.CUSTOM_BUILD_INDEX] ?? {}).length >= i + 2 ? "Yes" : "No",
    };
  });

  const lines = [1, 2, 3, 4].map((i) => {
    const key = `line${i}`;
    const line = oldModelsData[ModelIndexes.CONSTANT_LINE]?.[key] || {};
    return {
      lineName: line?.lineName,
      calculationApproach: line?.calculationApproach,
      radioAddLine: Object.keys(oldModelsData[ModelIndexes.CONSTANT_LINE] ?? {}).length >= i + 2 ? "Yes" : "No",
    };
  });

  const values = [null, 1, 2, 3, 4].map((i) => {
    const key = i === null ? "line" : `line${i}`;
    return {
      value: oldModelsData[ModelIndexes.CONSTANT_LINE]?.[key]?.value,
    };
  });

  const derivedValueApproach = [null, 1, 2, 3, 4].map((i) => {
    const key = i === null ? "line" : `line${i}`;
    return {
      derivedDataCalculationApproach: oldModelsData[ModelIndexes.CONSTANT_LINE]?.[key]?.derivedDataCalculationApproach,
    };
  });

  const derivedValueTimeSeries = [null, 1, 2, 3, 4].map((i) => {
    const key = i === null ? "line" : `line${i}`;
    return {
      timePeriod: oldModelsData[ModelIndexes.CONSTANT_LINE]?.[key]?.timePeriod,
      calculation: oldModelsData[ModelIndexes.CONSTANT_LINE]?.[key]?.calculation,
      companyName: oldModelsData[ModelIndexes.CONSTANT_LINE]?.[key]?.company?.name,
    };
  });
  const derivedValuePointInTime = [null, 1, 2, 3, 4].map((i) => {
    const key = i === null ? "line" : `line${i}`;
    return {
      Date: dayjs(oldModelsData[ModelIndexes.CONSTANT_LINE]?.[key]?.Date),
      premiumToDate: oldModelsData[ModelIndexes.CONSTANT_LINE]?.[key]?.premiumToDate,
      companyName: oldModelsData[ModelIndexes.CONSTANT_LINE]?.[key]?.company?.name,
    };
  });

  return {
    dataSource,
    oldModelsData,
    indexationCompanyNames,
    indexationValue,
    indices,
    lines,
    values,
    derivedValueApproach,
    derivedValueTimeSeries,
    derivedValuePointInTime,
  };
};
